<template>
 
  <div :class="`theme--${data.themeType=='TuktukStep1' ? 'Tuktuk' : data.themeType}`">
    <template v-if="data.themeType=='TuktukStep1'">
      <flash-sale
        v-show="data.showFlashSale && step == 1"
        theme="tuktuk-1-step"
        :flashSaleData="data.flashSaleSettings"
        :form-id="data.form_id"
        :isMobile="isMobile"
        :style="{marginBottom: !isMobile ? '16px' : ''}"
      />
      <ProductDetails    
          @updateCartQuantity="updateCartQuantity"
          @addCartItem="addCartItem"
          @updateCartSummary="updateCartSummary"
          @setStep="setStep"
          @changeVariant="onChangeVariant"
          :data="{ ...data, productImages: filteredProductImages, variantImageIndex,changeVariant,changeVariantItem }"
          @addToCart="addToCart"
          @showMsg="showMsg"
          @applyDiscount="applyDiscount"
          @clearDiscount="clearDiscount"
          @updateDiscountLists="updateDiscountLists"
          :showCaptcha="showCaptcha" 
        />    
      
            <Checkout
              :user="user"      
              :is-mobile="isMobile"
              @updateCartQuantity="updateCartQuantity"
              :submited="submited"
              @onSubmitted="onSubmitted"
              @addCartItem="addCartItem"
              @updateCartTotal="updateCartTotal"
              @updateCartSummary="updateCartSummary"
              @calcCart="calcCart"
              @changeVariant="onChangeVariant"
              @setStep="setStep"
               @addToCart="addToCart"
              :shippingCourierItems="shippingCourierItems"
              :isInvalidCustomerPhone="isInvalidCustomerPhone"
              :data="{ ...data, productImages, variantImageIndex , changeVariant,changeVariantItem}"
              :shippingCourierTypesCargo="shippingCourierTypesCargo"
              @applyDiscount="applyDiscount"
              @clearDiscount="clearDiscount"
              @updateDiscountLists="updateDiscountLists"
              @reset-invalid-phone="$emit('reset-invalid-phone')"
              :showCaptcha="showCaptcha"
              @setSelectedAddresses="setSelectedAddresses"
            />                
        
    </template>
    <template v-else>
    <flash-sale
      v-show="data.showFlashSale && step == 1"
      theme="tuktuk"
      :flashSaleData="data.flashSaleSettings"
      :form-id="data.form_id"
      :isMobile="isMobile"
      :style="{marginBottom: !isMobile ? '16px' : ''}"
    />

    <ProductDetails
          v-if="step == 1"
          @updateCartQuantity="updateCartQuantity"
          @addCartItem="addCartItem"
          @updateCartSummary="updateCartSummary"
          @setStep="setStep"
          @changeVariant="onChangeVariant"
          :data="{ ...data, productImages: filteredProductImages, variantImageIndex,changeVariant,changeVariantItem }"
          @addToCart="addToCart"
          @showMsg="showMsg"
          @applyDiscount="applyDiscount"
          @clearDiscount="clearDiscount"
          @updateDiscountLists="updateDiscountLists" 
          :showCaptcha="showCaptcha"
        />
        <div v-else>
          <no-ssr>
            <Checkout
              :user="user"      
              :is-mobile="isMobile"
              @updateCartQuantity="updateCartQuantity"
              :submited="submited"
              @onSubmitted="onSubmitted"
              @addCartItem="addCartItem"
              @updateCartTotal="updateCartTotal"
              @updateCartSummary="updateCartSummary"
              @calcCart="calcCart"
              @setStep="setStep"
              :shippingCourierItems="shippingCourierItems"
              :isInvalidCustomerPhone="isInvalidCustomerPhone"
              :data="{ ...data, productImages, variantImageIndex ,changeVariant,changeVariantItem, filteredProductImages}"
              @addToCart="addToCart"
              @changeVariant="onChangeVariant"
              @applyDiscount="applyDiscount"
              @clearDiscount="clearDiscount"
              @updateDiscountLists="updateDiscountLists" 
              :showCaptcha="showCaptcha"
              @reset-invalid-phone="$emit('reset-invalid-phone')"
              @setSelectedAddresses="setSelectedAddresses"
            />
      
          </no-ssr>
        </div>
    </template>
    
   
  </div>

</template>
<script>
import ProductDetails from "./ProductDetails/index.vue";
import Checkout from "./Checkout/index.vue";
import config from "./../../../config.js";
import { FlashSale } from "@formulir/components-checkout";
import { isCombinedWholesaleEnabled, combinedWholesaleUnitPrice, sumCartQuantity } from "@/helpers/wholesalePriceHelper";
import { cloneDeep } from "lodash";
import axios from 'axios';

export default {
  props: ["data", "submited", "shippingCourierItems", "user", "isMobile", "isInvalidCustomerPhone", "shippingCourierTypesCargo"],
  provide() {
    return {
      provider: {
        get isEmbed() {
          return false;
        }
      }
    }
  },
  data() {
    return {
      step: 1,
      productImages: cloneDeep(this.data.productImages),
      variantImageIndex: -1,
      baseUrl: config.api.replace("/api", ""),
      changeVariant:false,
      changeVariantItem:{},
      showCaptcha: false,
      isInvalid: false,
      isArchivedOrder: false
    };
  },
  components: {
    ProductDetails,
    Checkout,
    FlashSale
  },
  watch:{
    "data.requestedFields": {
      handler() {
        this.$emit("updateCheckout");
        // this.validate();
        // this.$emit("onValidate", true);
      },
      deep: true,
    },
    "data.variablePrices": {
      handler() {       
        this.updateProductImages();
        this.calcCart();
      },
      deep: true,
    },
    payload: {
      handler() {      
        this.$emit("updateCheckout");    
        this.calcCart();   
      },
      deep: true,
    },
    step: function() {
      if(this.data.nuxt2){
         window.scrollTo({ top: 0, behavior: 'instant' })
      }
     
    },
  },
  mounted() {
    this.updateProductImages();
    this.calcCart();
    this.checkCaptchaOnProduct();
    // if (localStorage.getItem("tuktukSummaryCheckout") && !this.data.embed) {
    //   this.storeData = JSON.parse(localStorage.getItem("tuktukSummaryCheckout"));           
    //   if(this.storeData.url==this.data.url && this.$route.query.step && this.$route.query.step==2){
    //     this.setStep(2);
    //   }else{
    //     if(this.$route.query.step){
    //       this.$router.replace({ path: this.data.url, params: {url:this.data.url} });      
    //     }   this.$router.push({
        
    //     });
    //   }
    // }else{
    //   if(this.$route.query.step && !this.data.embed){
    //       this.$router.replace({ path: this.data.url, params: {url:this.data.url} });      
    //     } 
    // }
    

   
   
    
  },
  computed:{
    filteredProductImages() {
       if(!this.data.showProductVariant) {
        return this.productImages.filter(img => img.name === undefined || img.name === null);
       }

       return this.productImages;
    },
    cartTotalPrice: {
      get() {
        return this.data.cartTotal;
      },
      set(val) {
        this.$emit("updateCartTotal", val);
      },
    },
  },
  methods: {
    setSelectedAddresses(addresses) {
      this.$emit('setSelectedAddresses', addresses)
    },
    updateDiscountLists(discounts,replace){
      this.$emit('updateDiscountLists',discounts,replace)
    },
    applyDiscount(discount){
      this.$emit("applyDiscount",discount);
    },
    updateCheckout(){
      this.$emit("updateCheckout");
    },
    clearDiscount(code){
      this.$emit("clearDiscount", code);
    },
    calcCart() {
      // this.totalBumpOrderPrice = this.totalBumpOrderPrice ? this.totalBumpOrderPrice : 0
      let price =
        0 +
        parseFloat(this.data.payload.deliveryPrice ? this.data.payload.deliveryPrice : 0);
      this.data.cartSummary.map(async (e) => {
        if (!e) return;
        let unitPrice = e.price ? e.price : e.priceOriginal;
        let subPrice = unitPrice * e.qty;
        if (isCombinedWholesaleEnabled(this.data)) {
          const combinedUnit = combinedWholesaleUnitPrice({
            whosaleData: e.whosaleData, base: unitPrice,
            cartTotalQty: sumCartQuantity(this.data.cartSummary),
            threshold: this.data.combinedWholesaleThreshold,
          });
          subPrice = combinedUnit * parseInt(e.qty);
        } else if (e.whosaleData) {
          e.whosaleData.map((one) => {
            const qtyForWholesale = parseInt(e.qty);
            if (one.count && parseInt(one.count) <= qtyForWholesale) {
              subPrice = one.price * parseInt(e.qty);
            }
            return subPrice;
          });
        }
        price = price + subPrice;
      });
      this.$emit("updateTotalOriginal",price);
     
      if (this.data.payload.payment == "COD") {
        price = price + parseFloat(this.data.codPrice);
      }
    
      if (this.data.payload.uniquePrice && this.data.payload.payment == "bankTransfer") {
        price =
          price +
          (this.data.codeType == "Decrease"
            ? -this.data.payload.uniquePrice
            : this.data.payload.uniquePrice);
      }
     
      const shippingConfig = this.data.payload.payment === 'COD' ? this.data.shippingCOD : this.data;
      if (shippingConfig.additionalCost && this.data.addShipping) {
        price = price + parseInt(shippingConfig.additionalCost);
      }
      if (shippingConfig.flatShippingPrice && shippingConfig.shippingType == "flat") {
        price = price + parseInt(shippingConfig.flatShippingPrice);
      }
      if (this.data.shippingDiscountValue && this.data.addShipping && shippingConfig.shippingType == "automated" && this.data.shippingDiscountValue > 0) {
        price = price - parseFloat(parseFloat(this.data.shippingDiscountValue));
      }
      
      // if (this.payload.bump) {
      //   price = price + parseFloat(this.data.bumpPrice)
      // }

      if (
        this.data.isBump &&
        this.data.bumpArray &&
        this.data.bumpArray.length >= 0 &&
        this.data.selectedbumpArray
      ) {
        // price = price + parseFloat(this.data.bumpPrice)
        this.data.selectedbumpArray.map((bumpData) => {
          //  const bumpData = this.data.bumpArray.find((data) => data.bump_id == bump_id)
          if (bumpData) {
            price = price + (bumpData.bumpPrice ? parseFloat(bumpData.bumpPrice) : 0);
            //  this.totalBumpOrderPrice = this.totalBumpOrderPrice + parseFloat(bumpData.bumpPrice)
          }
        });
      }
      if (typeof price == "string") {
        price = parseFloat(price);
      }
   
      for (const discount of this.data.payload.discounts) {
        if (discount.amount > 0){
          price -= discount.amount;
        }    
      }

      if(this.data.payload.automaticDiscount && this.data.payload.automaticDiscount["amount"] > 0){
        price = price-this.data.payload.automaticDiscount["amount"]
      }   
      // return parseInt(price.toFixed())
      this.cartTotalPrice = parseInt(price.toFixed()) + this.data.payload.ePayFee;
    },
    onChangeVariant(val){        
      if(val != undefined){
        if(typeof val=="object" && "status" in val){
          this.changeVariant=val.status;
          this.changeVariantItem=val.elem;
        }else{
          this.changeVariant=val;
        }
        if(!val){
          this.changeVariantItem={};
        }        
      }
     
    },
    setStep(count) {
      if((this.data.nuxt2 && process.client) || !this.data.nuxt2){    
      this.step = count;         
      if(count==2){    
        const storeData={
          selectedbumpArray:this.data.selectedbumpArray,
          cartQuantity:this.data.cartQuantity,
          payloadVariablePrices:this.data.payload.variablePrices,
          variablePrices:this.data.variablePrices.map(a=>{ return {qty:a.qty}}),
          cartSummary:this.data.cartSummary,
          url:this.data.url
        }    
        if(!this.data.embed){   
          localStorage.setItem("tuktukSummaryCheckout", JSON.stringify(storeData), {
            expires: new Date(new Date().getTime() + 30 * 60 * 1000),
          });
          if(!this.$route.query.step){
            this.$router.replace({ path:this.data.url, params: {url:this.data.url}, query: {step: count, ...this.$route.query} });      
          }   
        }     
      }else{
        if(!this.data.embed){
          this.$router.replace({ path: this.data.url, params: {url:this.data.url}})
        }
        
      }
    }
    },
    onSubmitted() {
      this.$emit("onSubmitted");
    },
    addToCart(val) {
      this.$emit("addToCart",val);
    },
    showMsg() {
      this.$emit("showMsg");
    },
    updateCartQuantity(cartQuantity) {
      this.$emit("updateCartQuantity", cartQuantity);
      this.calcCart();
    },
    addCartItem() {
      this.$emit("addCartItem");     
    },
    updateCartSummary(index) {     
      this.$emit("updateCartSummary", index);
      this.calcCart();
    },
    updateCartTotal(val) {
      this.$emit("updateCartTotal", val);
    },
    updateProductImages() {
      this.productImages = [];
      this.data.images.map((img) => {
        this.productImages.push({ src: img });
      });

      this.data.variablePrices.map((v) => {
        v.image && this.productImages.push({ src: v.image, name: v.name });
      });

      let itemName = [];
      Object.keys(this.data.payload.variablePrices).map((key) => {
        itemName.push(this.data.payload.variablePrices[key].name);
      });

      this.variantImageIndex = this.productImages.findIndex(
        (x) => x.name == itemName.join(" / ")
      );   
      // if (variantImageIndex > -1) {
      //   this.variantImageIndex = variantImageIndex;
      // }
    },
    // captcha settings for checkout page
    async checkCaptchaOnProduct() {
      if (this.data.isCaptchaEnable) {
        const productId = this.data._id
        let res = await axios.post(config.api + 'order/getLast24HourOrders', { productId: productId, ip: this.data.ip, captchaSettings: this.data.captchaSettings })
        const orderData = res.data.orders
        if (res.data.success) {

          //Conditions to check captcha settings and enable captcha
          for (let objKey in this.data.captchaSettings) {
            const element = this.data.captchaSettings[objKey];
            if (element.isEnable) {
              if (element.type == 'setting1' && element.isEnable && element.orderCount <= orderData.setting1) {
                this.showCaptcha = true
              }
              if (element.type == 'setting2' && element.isEnable && element.orderCount <= orderData.setting2) {
                this.showCaptcha = true;
                this.isInvalid = true
              }
              if (element.type == 'setting3' && element.isEnable && element.orderCount <= orderData.setting3) {
                this.showCaptcha = true;
                this.isInvalid = true;
                this.isArchivedOrder = true
              }
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
 @import "@/assets/styles/pages/success.scss";
 @import '@/assets/styles/pages/checkout/components/form/Tuktuk/index.scss';
 @import '@/assets/styles/pages/checkout/components/form/Tuktuk/Checkout/index.scss';
 @import '@/assets/styles/pages/checkout/components/form/Tuktuk/ProductDetails/index.scss';
</style>
